<div class="wrap center">
    <div class="w-4-x w-5-l w-12 left p-b-8"
         style="padding-top: 7.6em">

        <!-- title -->
        <h1 class="h2">{{'Reset password' | translate}}</h1>

        <form name="reset_password"
              method="POST"
              #form="ngForm">
            <!-- password field -->
            <input-wrap>
                <input class="input"
                       type="password"
                       name="password"
                       [muiInput]="'New password'"
                       placeholder="Enter a new a password"
                       required
                       [(ngModel)]="data.password"
                       (keyup.enter)="submit()">

            </input-wrap>

            <!-- submit -->
            <div class="m-t">
                <button class="button w-12"
                        [action]="status"
                        (click)="submit()">
                    {{'Save password' | translate}}
                </button>
            </div>

            <!-- action result -->
            <result class="block m-t-1"
                    [status]="status"
                    success="New password saved, redirecting..."></result>
        </form>

    </div>
</div>